<template>
  <div class="emd-language-select">
    <select v-model="$i18n.locale" v-on:change="changeLanguage()">
      <option
        v-for="lang in langs"
        :key="lang.code"
        :value="lang.code">{{ lang.flag }} {{ lang.name }}</option>
    </select>
    <div class="emd-language-select__arrow"/>
  </div>
</template>
<script>
export default {
  name: 'EmdLanguageSelect',
  data () {
    return {
      langs: [
        {
          code: 'en-US',
          name: 'English',
          flag: '🇺🇸'
        },
        {
          code: 'pt-BR',
          name: 'Português',
          flag: '🇧🇷'
        }
      ]
    }
  },
  computed: {
    pref () {
      return this.$store.state.user.preferences
    }
  },
  methods: {
    changeLanguage () {
      this.$store.dispatch('SET_LANGUAGE', this.$i18n.locale)
    }
  },
  beforeMount: function () {
    this.$i18n.locale = this.pref.language
    this.$store.dispatch('SET_LANGUAGE', this.pref.language)
  }
}
</script>
